import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import styles from './GameEnvironmentSelector.module.sass';
import { useRootStore } from '../../../loaders/useRootStore';
import { ButtonGroup } from 'react-bootstrap';
import { useGameEnvironmentCssClass } from './useGameEnvironmentCssClass';

interface PropsType {
    [key: string]: any,

    disabled: boolean,
    gameEnvironmentFilter?: (ge: IGameEnvironment) => boolean
    selectedGameEnvironment?: IGameEnvironment,
    handleGameEnvironmentChange?: (targetGE: IGameEnvironment) => void,
}

export const GameEnvironmentSelector: FC<PropsType> = observer(({
                                                                    disabled,
                                                                    gameEnvironmentFilter,
                                                                    selectedGameEnvironment,
                                                                    handleGameEnvironmentChange,
                                                                    onlyGameVersionEnabledEnvironment,
                                                                    className,
                                                                    ...props
                                                                }) => {
    const rootStore = useRootStore();
    const cssClass = useGameEnvironmentCssClass(selectedGameEnvironment ?? rootStore.gameEnvironmentsStore.getCurrentGameEnvironment());

    const changeGameEnvironment = (targetGE: IGameEnvironment) => {
        handleGameEnvironmentChange && handleGameEnvironmentChange(targetGE);
    };

    const disabledState = rootStore.gameVersionStore.getCurrentGameVersion().name.toLowerCase() === 'staticdata' || disabled;

    return (
        <DropdownButton
            align="end"
            as={ButtonGroup}
            title={<><i
                className="fas fa-play-circle" /> {selectedGameEnvironment ? selectedGameEnvironment.name : rootStore.gameEnvironmentsStore.getCurrentGameEnvironment().name}</>}
            variant={cssClass.name}
            disabled={disabledState}
            className={`${styles.gameEnvSelector} gameEnvSelector ${className ?? ''}`}
            {...props}
        >
            {rootStore.gameEnvironmentsStore.gameEnvironments
                .filter((ge) => (gameEnvironmentFilter ? gameEnvironmentFilter(ge) : true))
                .map((env) => {
                    return (
                        <Dropdown.Item key={env.id} as="button" onClick={() => changeGameEnvironment(env)}>
                            {env.name}
                        </Dropdown.Item>
                    );
                })}
        </DropdownButton>
    );
});

